export const formatErrorResponse = (error) => {
    // Handle case where error is just a string
    if (typeof error === 'string') {
        return error;
    }

    const errorDetails = error.response?.request?.responseText || // Django REST detailed error
                        error.response?.data?.detail || // Django REST detail field
                        error.message || // Basic error message
                        error.toString(); // Fallback to string conversion
    
    // Format JSON error message if it's a string
    if (typeof errorDetails === 'string') {
        try {
            if (errorDetails.length > 300) {
                return "An unexpected error occurred"
            }
            const parsedError = JSON.parse(errorDetails)
            
            // Check for composite uniqueness error (non_field_errors)
            if (parsedError.non_field_errors) {
                // Return the main error message from non_field_errors
                const mainMessage = Array.isArray(parsedError.non_field_errors) 
                    ? parsedError.non_field_errors[0] 
                    : parsedError.non_field_errors;
                return mainMessage;
            }
            
            // Format other field errors
            const formattedErrors = Object.entries(parsedError)
                .filter(([field]) => field !== 'non_field_errors') // Skip non_field_errors as we handled it above
                .map(([field, messages]) => {
                    // Handle both array and string message formats
                    const messageStr = Array.isArray(messages) ? messages.join(', ') : messages;
                    return `${field}: ${messageStr}`;
                })
                .join('\n')
            
            return formattedErrors || "An error occurred"
        } catch (error) {
            return errorDetails
        }
    } 
    return errorDetails
}